export default {"src":"/_next/static/media/document-icon.c12d9dfd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};